/* Built In Components */
import { useEffect } from 'react';

/* External Components */
/* Components */
// Internal Imports
/* Services */
/* Styles */

/**
 * Renders the Build Time Comment Component
 * @returns {ReactElement} - NoPaperFormScript Component
 */
const NoPaperFormsScript = () => {
  useEffect(() => {
    window.npf_d = 'https://apply.isha.sadhguru.org';
    window.npf_c = '6716';
    window.npf_m = '1';

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://track.nopaperforms.com/js/track.js';

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return null;
};

export default NoPaperFormsScript;
